import ShareModel from '@/Models/Share/ShareModel';

/**
 * Transforms Share to backend dto
 * @param {ShareModel} share
 * @returns {Object}
 */
export const NewShareRequest = share => {
  return share;
};
